/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';
import defaultsDeep from 'lodash/defaultsDeep';
import DotComponent from '../../ui/DotComponent';
import Spacer from '../../ui/Spacer';
import { Container, Row, Column } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import LanguageItem from './LanguageItem';
import * as styles from './index.styles';

const defaultData = {
  Headline: {
    value: '',
  },
  Languages: {
    value: [],
  },
};

export class LanguageSelector extends SafePureComponent {
  /**
   * @param code language code
   * this function takes the redirectedPage item from local storage and substracts the path after the '/lang-country/' format
   * and returns in an array with the first element the previous language and the second one the previous page.
   * if there is no previous page after the transformation, it would take path as the home page: '/'.
   */
  onLanguageSelected = code => {
    const baseUrl = window.location.origin;
    // eslint-disable-next-line no-undef
    let path = localStorage.getItem('redirectedPage');
    path = path && path.substr(1).split(/\/(.+)/);
    path = path && path.length > 1 ? path[1] : '';
    const newUrl = `${baseUrl}/${code}/${path}`;
    // eslint-disable-next-line no-undef
    localStorage.removeItem('redirectedPage');
    window.location.replace(newUrl);
  };

  renderHeadline = fields => {
    const { Headline } = fields;
    return (
      <Row>
        <Column offsets={{ lg: 1 }}>
          <h2 css={styles.headlineCss}>
            <Text field={Headline} />
            <DotComponent />
          </h2>
        </Column>
      </Row>
    );
  };

  safeRender() {
    const { props } = this;
    const { t } = props;
    const fields = defaultsDeep(props.fields, defaultData);
    const { Languages } = fields;

    return (
      <Spacer marginCss={styles.containerMarginCss}>
        <Container>
          {this.renderHeadline(fields)}
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 10, xl: 10 }} offsets={{ lg: 1 }}>
              <Row>
                {Languages.value.length > 0 &&
                  Languages.value.map(language => (
                    <Column
                      tabIndex="0"
                      css={styles.languageCss}
                      key={language.name}
                      cols={{
                        sm: [6, 6],
                        md: [2, 8],
                        lg: [2, 10],
                      }}
                      onClick={() => this.onLanguageSelected(language.code)}
                    >
                      <LanguageItem language={language} t={t} />
                    </Column>
                  ))}
              </Row>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

LanguageSelector.displayName = 'LanguageSelector';

LanguageSelector.defaultProps = {
  t: key => key,
  Headline: { value: '' },
  Languages: { value: [] },
};

export default compose(
  withNamespaces(),
  withSitecoreContext(),
)(LanguageSelector);
